import {NavLink} from "react-router-dom";
import React, {useState} from "react";
import {authConfig} from "../../Providers/AuthProvider";
import {Button, ColourSolid} from "@twigsby/frontend-framework";

const SignupDevNav = () => {
    const [ tokenShow, setTokenShow] = useState<boolean>(false);

    return(
        <>
            <div className={'btn-group text-center'}>
                <NavLink to={'/'} className={'btn secondary'}>Old Signup</NavLink>
                <NavLink to={'/signup-3'} className={'btn secondary'}>New Signup</NavLink>
                <Button title={'Show Token'} onClick={() => setTokenShow(!tokenShow)} colour={tokenShow ? ColourSolid.Success : ColourSolid.Secondary}/>
            </div>

            {tokenShow && (
                <div style={{ whiteSpace: 'pre' }}>
                    {JSON.stringify(authConfig, null, 4)}
                </div>
            )}
        </>
    )
}

export default SignupDevNav
